import { useRef } from "react";
import {
  Flex,
  Text,
  MenuItem,
  Menu,
  MenuButton,
  MenuList,
  IconButton,
  Tooltip,
  Box,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { IconeDownload } from "../IconeDownload";
import { ImCross } from "react-icons/im";
import { useHistory } from "react-router";
import CriancaService from "../../../main/services/CriancaService";
import FiliacoesService from "../../../main/services/FiliacoesService";
import { handleVerifyRedirect } from "../../utils/handleVerifyRedirect";
import { anexosFunc, criancaFunc } from "../../../helpers/Funcionalidades";
import { useAppContext } from "../../../Context/MessageContextProvider";
import AnexosSAService from "../../../main/services/AnexosSAService";

import { servicoAcolhimentoFunc } from "../../../helpers/Funcionalidades";

export function CardAnexo({
  title,
  dataDocumento,
  responsavel,
  dataInitial,
  observacoes,
  idDelete,
  idCrianca,
  tipoAnexo,
  fetchData,
  idade16,
  roleKeycloack,
  user,
  idOrgaoExterno,
  idOrgao,
  tipoCard,
  fotoPrincipal,
  setLoadingPainel,
}) {
  const history = useHistory();
  const { setRadioClick } = useAppContext();

  const idTipoSituacaoJuridica = [13, 14, 15, 16, 17];
  const idTipoRedirect = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 20, 22, 23, 27,
    36, 38, 39, 40,
  ];
  const showMenuItems =
    idade16 &&
    ((roleKeycloack?.includes(anexosFunc.abaAnexoRedirecionar) &&
      idTipoRedirect.includes(tipoAnexo?.tipoAnexo?.id) &&
      (!idTipoSituacaoJuridica.includes(tipoAnexo?.tipoAnexo?.id) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudo) ||
        roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
        roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarParteTJ))) ||
      (!idTipoRedirect.includes(tipoAnexo?.tipoAnexo?.id) &&
        (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar) ||
          roleKeycloack?.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          )) &&
        (user?.orgaoExternoOriginal?.includes(idOrgaoExterno) ||
          user?.orgaoExternoOriginal?.includes(idOrgao))) ||
      (!idTipoRedirect.includes(tipoAnexo?.tipoAnexo?.id) &&
        (roleKeycloack?.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarParteTJ))));
  const responsavelRef = useRef(null);
  const observacoesRef = useRef(null);

  const idTipoMenosMargem = [
    7, 8, 9, 11, 19, 20, 21, 22, 23, 26, 27, 28, 32, 35,
  ];

  const messageDeleteRedirect = () => {
    Swal.fire({
      title: "Atenção!",
      text: "Ao excluir, o documento será excluído. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteAnexoCrianca(idDelete)
          .then((res) => {
            fetchData();
            setLoadingPainel(true);
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {});
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  const deleteAnexo = (idDelete) => {
    if (handleVerifyRedirect(tipoAnexo, history, idCrianca)) {
      if (tipoAnexo.tipoAnexo?.id === 1 && fotoPrincipal === false) {
        messageDeleteRedirect();
      } else {
        handleVerifyRedirect(tipoAnexo, history, idCrianca, true);
      }
    } else {
      messageDeleteRedirect();
    }
  };

  const getAnexoGuia = (id, option) => {
    if (tipoAnexo.tipoAnexo.idFiliacao) {
      FiliacoesService.getCertidaoObitoDownload(
        tipoAnexo.tipoAnexo.idFiliacao,
        id
      )
        .then((res) => {
          if (option === "download") {
            const downloadUrl = res.config.url;
            window.open(downloadUrl, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      CriancaService.getAnexo(id, option)
        .then((res) => {
          if (option === "download") {
            const downloadUrl = res.config.url;
            window.open(downloadUrl, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const getAnexoServico = (id, option) => {
    AnexosSAService.getAnexo(id, option)
      .then((res) => {
        if (option === "download") {
          const downloadUrl = res.config.url;
          window.open(downloadUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Flex
      position="relative"
      w="250px"
      h="190px"
      boxShadow="0px 4px 3px 0px rgba(0, 0, 0, 0.25)"
      border="solid 1px #E3E2E2"
      px="4"
      py="2"
      rounded="md"
      flexDirection={"column"}
      backgroundColor={"#F0F7F7"}
    >
      <Text
        fontWeight={700}
        fontSize="13.7px"
        lineHeight="21.6px"
        color={"#169499"}
      >
        {title}
      </Text>
      <Text
        fontSize="12px"
        fontWeight={700}
        lineHeight="21.6px"
        color={"#5F6377"}
      >
        {dataDocumento ? (
          <>
            Data do Documento:{" "}
            <Text as="span" fontWeight={500} color="#6B6C71">
              {dataDocumento}
            </Text>
          </>
        ) : (
          ""
        )}
      </Text>
      <Box position="relative">
        <Tooltip
          label={responsavel}
          fontSize="md"
          textAlign={"justify"}
          wordBreak={"break-all"}
        >
          <Text
            ref={responsavelRef}
            wordBreak={"break-word"}
            fontSize="12px"
            fontWeight={700}
            color={"#5F6377"}
            display="-webkit-box"
            overflow="hidden"
            style={{
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {responsavel ? (
              <>
                Responsável:{" "}
                <Text as="span" fontWeight={500} color="#6B6C71">
                  {responsavel}
                </Text>
              </>
            ) : (
              ""
            )}
          </Text>
        </Tooltip>
      </Box>
      <Box
        mt={idTipoMenosMargem?.includes(tipoAnexo?.tipoAnexo?.id) ? 2 : 6}
        mb={idTipoMenosMargem?.includes(tipoAnexo?.tipoAnexo?.id) ? 2 : 0}
        position="relative"
      >
        <Tooltip
          label={observacoes}
          fontSize="md"
          textAlign={"justify"}
          wordBreak={"break-all"}
        >
          <Text
            ref={observacoesRef}
            wordBreak={"break-word"}
            fontSize="12px"
            fontWeight={700}
            display="-webkit-box"
            overflow="hidden"
            style={{
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
            color={"#5F6377"}
          >
            {observacoes ? (
              <>
                {tipoCard === "servico" ? "Descrição:" : "Observações:"}{" "}
                <Text as="span" fontWeight={500} color="#6B6C71">
                  {observacoes}
                </Text>
              </>
            ) : (
              ""
            )}
          </Text>
        </Tooltip>
      </Box>

      <Flex
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        px="4"
        py="2"
        justifyContent="space-between"
      >
        <Text
          fontWeight={500}
          fontSize="12px"
          lineHeight="19.6px"
          color="#6B6C71"
        >
          {dataInitial ? `Incluído em ${dataInitial}` : ``}{" "}
        </Text>
        <Flex alignItems="center" gap={4}>
          <button
            style={{ height: "18px" }}
            type="button"
            onClick={() =>
              tipoCard === "servico"
                ? getAnexoServico(idDelete, "download")
                : getAnexoGuia(idDelete, "download")
            }
          >
            <IconeDownload />
          </button>
          {showMenuItems && (
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<BsThreeDots color="#fff" fontSize="18px" />}
                variant={"link"}
                cursor={"pointer"}
                minW="22px"
                minH="22px"
                backgroundColor="#95BCBF"
                rounded={100}
              />

              <MenuList width="min-content" minWidth="240px">
                {showMenuItems && (
                  <>
                    <MenuItem
                      p={2}
                      color={"#374BCE"}
                      onClick={() => {
                        if (
                          handleVerifyRedirect(tipoAnexo, history, idCrianca)
                        ) {
                          handleVerifyRedirect(
                            tipoAnexo,
                            history,
                            idCrianca,
                            true,
                            setRadioClick
                          );
                        } else {
                          history.push(
                            `/crianca/editar-anexos/${idCrianca}/${idDelete}`
                          );
                        }
                      }}
                    >
                      <FiEdit />
                      <Text ml="5px" fontSize={"md"}>
                        Editar
                      </Text>
                    </MenuItem>

                    <MenuItem
                      p={2}
                      color={"red.500"}
                      onClick={() => deleteAnexo(idDelete)}
                    >
                      <ImCross />
                      <Text ml="5px" fontSize={"md"}>
                        Excluir
                      </Text>
                    </MenuItem>
                  </>
                )}
              </MenuList>
            </Menu>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}
